import React, { FC, useMemo } from 'react';
import { FooterModeType, useLayoutByPage } from 'Client/hooks/useLayoutByPage';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import loadable from '@loadable/component';
import useConfig from 'AppShell/hooks/useConfig';
import useGa from 'AppShell/hooks/useGa';

const CartFooter = loadable(() => import('Client/components/OneFooter/CartFooter'));
const OneWestwingFooter = loadable(() => import('../../../OneWestwingFooter'));
const OneFooter = loadable(() => import('Client/components/OneFooter/OneFooter'));

const Footer: FC = () => {
    const { footerMode } = useLayoutByPage();
    const { p100OneWestwingFooter } = useFeatureToggle();
    const config = useConfig();
    const ga = useGa();
    const trackingHelpers = useMemo(
        () => ({
            ga: {
                trackNonInteractiveGenericEvent: ga.trackGenericEvent.bind(ga),
                trackInteractiveGenericEvent: ga.trackInteractiveGenericEvent.bind(ga),
            },
        }),
        [ga]
    );

    if (footerMode === FooterModeType.NONE) {
        return null;
    }

    if (p100OneWestwingFooter) {
        return (
            <OneWestwingFooter
                isMiniMode={footerMode === FooterModeType.MINI}
                trackingHelpers={trackingHelpers}
                country={config.currentCountry}
            />
        );
    }

    if (footerMode === FooterModeType.CART) {
        return <CartFooter />;
    }

    return <OneFooter />;
};

export default Footer;
